import React, { useEffect } from 'react'
import { RouteComponentProps, useLocation, useHistory } from 'react-router-dom';
import { useGlobal, useDispatch } from 'reactn';
import IForfettariAppBar from '../../appBar/IForfettariAppBar';
import Main from '../../components/main';
import { Principal } from '../../models/principal';
import { IGlobalState, InEditingMode } from '../../states/GlobalState';
import PrincipalEdit from './edit';

type PageEditPrincipalProps = RouteComponentProps<any>;

export const PrincipalDetail = (props: PageEditPrincipalProps) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const history = useHistory();
    const [currentEditPrincipal] = useGlobal<IGlobalState, 'currentEditPrincipal'>('currentEditPrincipal');
    const oidIndex = location.pathname.lastIndexOf('/')
    const oid = parseInt(location.pathname.substring(oidIndex + 1))
    
    // TODO
    console.log('Principal id is: ' + oid);
    const Principal = currentEditPrincipal?.principal;

    useEffect(() => {
        // Il seguente è per non eseguire cambio di pagina durante il render
        if(!Principal) 
            history.push('/Principal');
    }, [Principal, history])

    // dispatch.setCurrentEditPrincipalAndMode(Principal!, oid > 0 ? 'Edit' : 'New');
    const initialMode = oid > 0 ? InEditingMode.Edit : InEditingMode.New;
    return ( 
        <div style={{ backgroundColor: "#e3e3e3", minHeight: "100vh" }}>
            <IForfettariAppBar title="Principal" handleLoad={() => {}}></IForfettariAppBar>
            <Main>
                <PrincipalEdit initialMode={initialMode} /> 
            </Main>
        </div>    
    )
}




